(ns assemble.templates-page.upload-modal.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/system/Stack$default" :as Stack]
            ["react-dropzone-new" :refer [useDropzone]]
            ["react-use/lib/useBeforeUnload$default" :as useBeforeUnload]
            ["react-use/lib/useMeasure$default" :as useMeasure]
            [assemble.component.upload-modal :as upload-modal]
            [assemble.resource.template :as resource.template]
            [assemble.templates-page.upload-modal.db :as db]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui template-name-form [{:keys [header-height]}]
  (let [[template-option set-template-option] (uix/use-state "")]
    ($ :<>
       ($ Grid
          {:flex 1
           :container true
           :direction "column"
           :onClick (fn [e]
                      (.stopPropagation e))}

          ($ Grid
             {:sx #js {:height header-height
                       :borderBottom 1
                       :borderColor "grey.60"
                       :px 2}}
             ($ Typography
                {:variant "h4"
                 :sx #js {:lineHeight (str header-height "px")}}
                "Add Template"))

          ($ Grid
             {:sx #js {:p 2
                       :pt 4}}

             ($ form-field
                {:label "Template name"}
                ($ input
                   {:data-testid "nameInput"
                    :autoFocus true
                    :value (:name template-option "")
                    :onChange (fn [e]
                                (set-template-option {:name (-> e .-target .-value)}))}))))

       ($ DialogActions
          ($ Button
             {:color "primary"
              :data-testid "cancelButton"
              :onClick #(rf/dispatch [::db/close])}
             "Cancel")
          ($ Button
             {:variant "contained"
              :color "primary"
              :disabled (empty? template-option)
              :data-testid "nextButton"
              :onClick #(rf/dispatch [::db/set-template-option template-option])}
             "Next")))))

(def type-column
  #js {:field "type"
       :headerName "Type"
       :valueGetter (fn [_value row ^js _column ^js _apiRef] (:template-type row))
       :renderCell (fn [^js o]
                     (let [template-type (.-value o)]
                       ($ Stack
                          {:direction "row"
                           :alignItems "center"
                           :spacing 1}
                          ($ Icon
                             {:sx #js {:color "grey.50"}}
                             (case template-type
                               "html" "personal_video"
                               "after-effects" "ondemand_video"
                               nil))
                          ($ Typography
                             {:sx #js {:textTransform "uppercase"
                                       :fontWeight "600"}}
                             template-type))))
       :sortable false
       :width 180})

(def dimensions-column
  #js {:field "dimensions"
       :headerName "Dimensions"
       :valueGetter (fn [_value row ^js _column ^js _apiRef] (select-keys (:metadata row) [:width :height]))
       :renderCell (fn [^js o]
                     (let [{:keys [width height]} (.-value o)]
                       (when width
                         (str width "x" height))))
       :sortable false
       :width 100})

(def action-column
  (upload-modal/create-action-column
   {:on-retry (fn [_e ^js o] (rf/dispatch [::resource.template/retry-upload (:id (.-row o))]))
    :on-delete (fn [_e ^js o] (rf/dispatch [::db/remove-queue-item (:id (.-row o))]))}))

(def columns
  #js [upload-modal/name-column
       type-column
       dimensions-column
       ;; FIXME: Combine this to dimensions or something?
       upload-modal/upload-status-column
       action-column])

(defui new-template-modal []
  (let [queue (use-subscribe [::db/get-queue])
        ;; FIXME: Own state for templates page
        modal-open (use-subscribe [::db/modal-open])
        {:keys [selected-template]} (use-subscribe [::db/props])

        active-upload (boolean (upload-modal/queue-first-by-status queue "uploading"))
        [measure-header-ref measure-header] (useMeasure)
        ;; If there is a template in the queue, we don't want anyone to drop
        ;; another template for upload.
        no-drag (> (count queue) 0)
        dropzone (useDropzone #js {:onDrop (fn [files] (rf/dispatch [::db/set-queue files]))
                                   :multiple false
                                   :noDrag no-drag})

        header-height (.-height measure-header)
        props {:dropzone        dropzone
               :columns         columns
               :queue           queue
               ;; Used by e.g. the placeholder component to select the correct texts
               ;; could be refactored away, and correct texts provided here directly.
               :asset-type      :templates
               :on-cancel       #(rf/dispatch [::db/close])
               :on-start-upload (fn [_]
                                  (rf/dispatch [::resource.template/start-upload]))}]
    ;; Note: if we allow closing the modal while we have uploads in progress,
    ;; this should be also moved to a place where it is called always.
    (useBeforeUnload active-upload "You have unsaved changes, are you sure?")
    ($ upload-modal/modal-dialog
       {:header-height header-height
        :measure-header-ref measure-header-ref
        :modal-open modal-open
        :on-close #(rf/dispatch [::db/close])
        :parent-nodes (rest (use-subscribe [:assemble.page.assets.file-tree/parent-nodes]))}
       (cond
         (empty? selected-template)
         ($ template-name-form (assoc props :header-height header-height))

         (seq queue)
         ($ upload-modal/upload-files-list (assoc props :header-height header-height))

         :else
         ($ upload-modal/upload-area-placeholder-view props)))))
